"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcTileWidth = exports.isAllRowSelected = exports.isAllColumnSelected = exports.getRowCellsSelected = exports.getColumnCellsSelected = exports.getMarginLeftSunIcon = exports.getSunIconPosition = exports.SUN_ICON_POSITION = exports.SPACE_VERTICAL_TILE = exports.SPACE_HORIZONTAL_TILE = void 0;
const helpers_1 = require("../helpers");
const createTheme_1 = require("../themes/createTheme");
const View_1 = require("../View");
const types_1 = require("./types");
exports.SPACE_HORIZONTAL_TILE = View_1.INDENT.xs;
exports.SPACE_VERTICAL_TILE = View_1.INDENT.xs;
var SUN_ICON_POSITION;
(function (SUN_ICON_POSITION) {
    SUN_ICON_POSITION["firstColumn"] = "firstColumn";
    SUN_ICON_POSITION["lastColumn"] = "lastColumn";
    SUN_ICON_POSITION["unknown"] = "unknown";
})(SUN_ICON_POSITION = exports.SUN_ICON_POSITION || (exports.SUN_ICON_POSITION = {}));
const getSunIconPosition = ({ rowIndexForSunIcon, columns }) => {
    if (rowIndexForSunIcon === undefined) {
        return SUN_ICON_POSITION.unknown;
    }
    const hasColumnHeaderRenderCel = columns.some(({ renderCel }) => !!renderCel);
    if (rowIndexForSunIcon < 0) {
        console.warn('SchedulingMatrix Error: the value of "rowIndexForSunIcon" property of "rowIndexForSunIcon" property must be greater than zero.');
        return SUN_ICON_POSITION.firstColumn;
    }
    if (rowIndexForSunIcon === 0) {
        return SUN_ICON_POSITION.firstColumn;
    }
    if (hasColumnHeaderRenderCel) {
        return SUN_ICON_POSITION.unknown;
    }
    if (rowIndexForSunIcon === columns.length - 1) {
        return SUN_ICON_POSITION.lastColumn;
    }
    if (rowIndexForSunIcon > columns.length - 1) {
        console.warn('SchedulingMatrix Error: the value of "rowIndexForSunIcon" property of "rowIndexForSunIcon" property must be less than the number of columns.');
        return SUN_ICON_POSITION.lastColumn;
    }
    return SUN_ICON_POSITION.unknown;
};
exports.getSunIconPosition = getSunIconPosition;
const getMarginLeftSunIcon = ({ rowIndexForSunIcon, sideOffset, tileSize }) => {
    const tileWidth = parseInt((0, exports.calcTileWidth)(tileSize), 10);
    const spaceHorizontalTileInt = 2 * parseInt((0, createTheme_1.createTheme)().spacing[exports.SPACE_VERTICAL_TILE], 10);
    if (rowIndexForSunIcon !== undefined) {
        return rowIndexForSunIcon === 0
            ? 0
            : sideOffset +
                tileWidth +
                spaceHorizontalTileInt +
                (tileWidth + spaceHorizontalTileInt) * (rowIndexForSunIcon - 1);
    }
    return undefined;
};
exports.getMarginLeftSunIcon = getMarginLeftSunIcon;
function getColumnCellsSelected({ columnIndex, columns, rows }) {
    var _a, _b;
    const selectedItems = [];
    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        selectedItems.push({
            rowIndex,
            columnIndex,
            rowKey: (_a = rows[rowIndex]) === null || _a === void 0 ? void 0 : _a.key,
            columnKey: (_b = columns[columnIndex]) === null || _b === void 0 ? void 0 : _b.key
        });
    }
    return selectedItems;
}
exports.getColumnCellsSelected = getColumnCellsSelected;
function getRowCellsSelected({ rowIndex, columns, rows }) {
    const selectedItems = [];
    for (let columnIndex = 0; columnIndex < columns.length; columnIndex++) {
        selectedItems.push({
            rowIndex,
            columnIndex,
            rowKey: rows[rowIndex].key,
            columnKey: columns[columnIndex].key
        });
    }
    return selectedItems;
}
exports.getRowCellsSelected = getRowCellsSelected;
function isAllColumnSelected({ columnIndex, isSelected, columns, rows, data }) {
    var _a;
    let countTileSelected = 0;
    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        if (isSelected({
            rowIndex,
            columnIndex,
            data,
            rowKey: (_a = rows[rowIndex]) === null || _a === void 0 ? void 0 : _a.key,
            columnKey: columns[columnIndex].key
        })) {
            countTileSelected++;
        }
    }
    return countTileSelected === rows.length;
}
exports.isAllColumnSelected = isAllColumnSelected;
function isAllRowSelected({ rowIndex, isSelected, columns, rows, data }) {
    var _a;
    let countTileSelected = 0;
    for (let columnIndex = 0; columnIndex < columns.length; columnIndex++) {
        if (isSelected({
            rowIndex,
            columnIndex,
            data,
            rowKey: (_a = rows[rowIndex]) === null || _a === void 0 ? void 0 : _a.key,
            columnKey: columns[columnIndex].key
        })) {
            countTileSelected++;
        }
    }
    return countTileSelected === columns.length;
}
exports.isAllRowSelected = isAllRowSelected;
const calcTileWidth = (size = types_1.SCHEDULING_MATRIX_TILE_SIZE.m) => {
    switch (size) {
        case types_1.SCHEDULING_MATRIX_TILE_SIZE.xxl:
            return helpers_1.SIZE_XXL;
        case types_1.SCHEDULING_MATRIX_TILE_SIZE.xl:
            return helpers_1.SIZE_XL;
        default:
            return helpers_1.SIZE_M;
    }
};
exports.calcTileWidth = calcTileWidth;
//# sourceMappingURL=helpers.js.map